import { useEffect, useState } from "react"
import ApiService from "../../../services/apiService"
import { method } from "lodash"
import { toast } from "react-toastify"
import Add from "../../table/Add"
import { validate } from "uuid"
import { useNavigate } from "react-router-dom"

const AddFarmer = ()=>{
       
      const[schemeVillage,setSchemeVillage] = useState<any>([])
      const navigate= useNavigate();
      useEffect(()=>{
          const fecthSchemeVillage = async()=>{
           try{
             const response = await ApiService.axiosApi(`/schemevillage`,{
                 method:'GET',
                 params:{
                     pageNumber:0,
                     pageSize:0

                 }
             })
             if(response.success){
                 setSchemeVillage(response.data.data)
             }else{
                 console.log(response.message || "unable to get village for farmer")
             }
           }catch(e){
             console.log('error:',e)
           }
        }
        fecthSchemeVillage();
      },[])

      const handleSubmit = async (data:any) =>{
         try{
             const response = await ApiService.axiosApi(`/farmer`,{
                  method:'POST',
                  data:data
             })
             if(response.success){
                 toast.success('Farmer Added Successsfully')
                 navigate(-1)

             }else{
                toast.error('Unable to add Farmer ')    
             }
         }catch(e){
             console.log(e)
         }
      }
    return(
        
        <Add
           title = {'Add Farmer'}
           parentTitle ={'Farmer'}
           onSubmit={handleSubmit}

           fields ={
              [
                {
                    name:'FarmerName',
                    label:'Farmer Name',
                    type:'text',
                    validation:{required:'Name is Required'}
                },
                {
                     name:'MobileNo',
                     label:'Mobile',
                     type:'text',
                     validation:{required:'NamMobile Number is Required'}
                },
                {
                     name:'EmailAddress',
                     label:'EmailAddress',
                     type:'text',
                     validation:{required:'Email Number is Required'} 
                },
                {
                   name:'Address',
                   label:'Address',
                   type:'text',
                   validation:{required:'Email Number is Required'}
                },
                {
                      name:'Scheme_Village',
                      label:'Scheme/Village',
                      isDropdown:true,
                      dropdownData:schemeVillage,
                      dropdownLabel:"scheme_Village",
                      idFieldName:"VillageId"
                }
              ]
           }
        />
       
    )
}

export default AddFarmer;